<template>
    <div class="page">
        <h1 class="text_13 page__title">
            <nuxt-link :to="{ name: 'lookbook' }" class="link-back">
                <svg-icon name="arrow-left--32" width="32" height="32" />
            </nuxt-link>
            {{ item.name }}
        </h1>
        <div class="lookbook">
            <UiImage
                v-for="(image, i_index) in item.images"
                :key="i_index"
                draggable="false"
                width="100%"
                lazy
                alt=""
                :path="image.path"
                :mobile="cropSize.m"
                @click.native="showMeFull(i_index, $device.isMobile)"
                :desktop="cropSize.d"></UiImage>
        </div>
        <ImagesModal
            :isSingle="fullImageSingle"
            :isOpen="fullImageOpen"
            :current="fullImageCurrent"
            @close="fullImageOpen = false"
            :images="item.images"></ImagesModal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import UiImage from "@/components/ui/Image";
import ImagesModal from "@/components/ImagesModal";
export default {
    name: "LookBookPage",
    components: { UiImage, ImagesModal },
    async asyncData({ $axios, params }) {
        const item = await $axios.get(`/api/looks/${params.slug}`);
        return { item: item.data };
    },
    head() {
        return {
            title: this.item.seo.title,
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.item.seo.description,
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.item.seo.description,
                },
            ],
        };
    },

    data() {
        return {
            fullImageSingle: false,
            fullImageOpen: false,
            fullImageCurrent: 0,
            cropSize: {
                d: { width: 630, height: 950 },
                m: { width: 216, height: 324 },
            },
        };
    },
    watch: {
        async langust() {
            await this.$nuxt.refresh();
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
        crumbs() {
            return [
                {
                    name: this.$i18n.t("lookbook"),
                    url: { name: "lookbook" },
                },
                {
                    name: this.item.name,
                },
            ];
        },
    },
    methods: {
        showMeFull(index = 0, is_single = false) {
            this.fullImageSingle = is_single;
            this.fullImageOpen = true;
            this.fullImageCurrent = index;
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
    },
};
</script>
<style lang="less" scoped>
.page__title {
    position: relative;
}
.link-back {
    position: absolute;
    left: 8px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
}
.lookbook {
    display: flex;
    flex-wrap: wrap;
    gap: 1px;

    picture {
        flex-basis: calc(100% / 3 - 1px);
        cursor: pointer;
        .trs(opacity);
        &:hover {
            opacity: 0.85 !important;
        }
    }
    @media @sm {
        background: #fff;
    }
}
</style>
